

let headerHeight = 30; //头部框的高度
let fieldHeight = 30; //字段框的高度
let width = 200; //table的宽度，不包含圆点

const renderGroup = function (el, group, i) {
    let nodes = group.nodes || [];
    let fieldsNum = nodes.length;

    let height = fieldsNum * fieldHeight + headerHeight
    //表外框
    var frame = el.rect({
        x: 0,
        y: 0,
        width: width,
        height: height,
        fill: "rgba(0,0,0,0.1)",
        // stroke:"red",
        rx: 4,
        ry: 4
    })
    //头部
    var header = el.rect({
        x: 0,
        y: 0,
        width: width,
        height: headerHeight,
        fill: "#3E7E9C"
    })
    // 头部文字
    var headertext = el.text(
        50, 20, group.name).attr({
            style: "font-size:12px",
            fill: "#fff",

        })

    var g = el.group(frame, header, headertext).addClass("hover-move")
    return g;
}

const renderNode = function (el, node, i) {
    let field = node;
    let rect = el.rect(0,  headerHeight, width, fieldHeight).attr({
        fill: "#cbeae1",
        stroke: "#fff",
    })
    let text = el.text(50,  headerHeight + 20, field.name).attr({
        style: "font-size:12px",
    })
    
    let g = el.g(rect, text).attr({ transform: `translate(0,${fieldHeight * i})`, });

    return g
}

const renderPort = function (el, port, portIndex, node, nodeIndex) {
  
    let circle = el.circle(0,0,0)
    if(port.direction == "left")
    circle = el.circle(0,  headerHeight + fieldHeight / 2, 0).attr({
        fill: "rgb(49, 208, 198)",
    }).addClass("hover-opacity")
    if(port.direction == "right")
    circle = el.circle(width,  headerHeight + fieldHeight / 2, 0).attr({
        fill: "rgb(49, 208, 198)",
        
    }).addClass("hover-opacity")
    return circle;

}

export default {
    renderGroup, renderNode, renderPort
}


// WEBPACK FOOTER //
// ./src/assets/tflow/render/group/tableRender.js